<template>
  <section class="home">
    <LandingPage />
    <DiscoverPage />
    <SolutionsPage />
    <BusinessPage />
    <FooterPage />
    <Footer />
  </section>
</template>

<script>
import LandingPage from '@/components/hgMain/LandingPage';
import DiscoverPage from '@/components/hgMain/DiscoverPage';
import SolutionsPage from '@/components/hgMain/SolutionsPage';
import BusinessPage from '@/components/hgMain/BusinessPage';
import FooterPage from '@/components/hgMain/FooterPage';
import Footer from '@/components/Footer';

export default {
  name: "Home",
  components: {
    LandingPage,
    DiscoverPage,
    SolutionsPage,
    BusinessPage,
    FooterPage,
    Footer
  }
};
</script>

<style scoped>

</style>

